import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function EnterpriseOpsCase() {
  return <CaseStudyPage slug="enterprise-operations-platform" />;
}